import { render } from "./RegelBenennen.vue?vue&type=template&id=765fe527&scoped=true"
import script from "./RegelBenennen.vue?vue&type=script&lang=js"
export * from "./RegelBenennen.vue?vue&type=script&lang=js"

import "./RegelBenennen.vue?vue&type=style&index=0&id=765fe527&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-765fe527"]])

export default __exports__